import React, { useState, useEffect, useMemo } from "react";
import { Alert, Button, Card, InputFecha, InputSelect, Title } from "../components";
import "../css/pages/ConfirmacionPago.css"
import { ErrorValidations } from "../enums-lists/Validations";
import { EntidadRecaudadora } from "../enums-lists/EntidadRecaudadora";
import { BancoRecaudador } from "../enums-lists/BancoRecaudador";
import { UserState, GroupedPaymentType } from "../types-interfaces/interfaces";
import { LuDownload } from "react-icons/lu";
import { getApiDateFormat, getDateFromTimestamp, moneyFormat } from "../functions/Format";
import { getPaymentList, paymentUpdateStatus } from "../services/api-ssrr/CollectionManagerAPIClient";
import { filterGroupedPayment, splitValue } from "../functions/Data";
import { AlertVariant, GroupedPaymentModel, PaymentModel, PaymentModelDetail } from "../types-interfaces/types";
import { SummaryAmountStyle, SummaryTableStyle } from "../components/styles/SummaryStyle";
import * as XLSX from 'xlsx';
import { PrimaryButtonStyle, SecondaryButtonStyle } from "../components/styles/ButtonStyle";
import { DetalleNoConfirmadoStyle } from "../components/styles/AlertStyle";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store"; 
import { useAppDispatch } from "../redux/hooks";
import { fetchPaymentTypes, selectPaymentTypes } from "../redux/slices/paymentType/PaymentTypeSlice";
import type {} from 'redux-thunk/extend-redux';
import { MRT_RowSelectionState, MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { columnsGroupedPayments, columnsGroupedPaymentsDetail } from "../enums-lists/TableColumns";
import { cloneDeep } from 'lodash';
import Modal from "../components/modal/Modal";
import ModalConfirm from "../components/modal/ModalConfirm";

interface ConfirmacionPagoProps extends React.HTMLAttributes<HTMLElement>{
  className: string | undefined
}

interface ConfirmacionPagoState {
  calendarHiddenInicio: boolean | undefined
  calendarHiddenFin: boolean | undefined;
  bancoRecaudador?: number
  entidadRecaudadora?: number
  medioPago?: string  
  fechaInicio?:string  
  fechaFin?:string
  pagosAConfirmar: number
  pagosCLP: number
  pagosUSD: number 
  errorFechaInicio: string
  errorFechaFin: string
  paymentsIds: Array<string>  
}

const initialState: ConfirmacionPagoState = {
  calendarHiddenInicio: true,
  calendarHiddenFin: true,
  bancoRecaudador: 0,
  entidadRecaudadora: 0,
  medioPago: "0",
  fechaInicio: '',
  fechaFin: '',  
  pagosAConfirmar: 0,
  pagosCLP: 0,
  pagosUSD: 0, 
  errorFechaFin: "",
  errorFechaInicio: "",
  paymentsIds: []
}

interface AlertInterface {variant: AlertVariant, text: string, detalleNoConfirmado: Array<PaymentModelDetail>, showTableDetalleNoConfirmado: boolean}
const fechaCiclo = new Date();  //TODO: arreglar fecha ciclo
const fechaMin = new Date();
fechaMin.setMonth(fechaMin.getMonth()-6);

function ConfirmacionPago (props:ConfirmacionPagoProps) {
  const [state,setState] = useState(initialState);
  const [rowSelectionPayments, setRowSelectionPayments] = useState<MRT_RowSelectionState>({});
  const [rowSelectionPaymentsDetails, setRowSelectionPaymentsDetails] = useState<Array<MRT_RowSelectionState>>([]);
  const [tableData, setTableData] = useState<Array<GroupedPaymentModel>>([]);
  const [filteredTableData, setFilteredTableData] = useState<Array<GroupedPaymentModel>>([]);
  const [selectedTableData, setSelectedTableData] = useState<Array<PaymentModelDetail>>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [paymentTypes, setPaymentTypes] = useState<Array<GroupedPaymentType>>([{ value: 0, name: 'Cargando...'}]);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const userState: UserState = useSelector<RootState, UserState>((state) => state.userState);
  const [alert, setAlert] = useState<AlertInterface>({variant: undefined, text: '',detalleNoConfirmado: [], showTableDetalleNoConfirmado: false })
  const [isLoadingTable, setIsLoadingTable] = React.useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchPaymentTypes(userState, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const paymentTypesFromAPI = useSelector<RootState, {loading: boolean, paymentTypes: Array<GroupedPaymentType>, error?: boolean}>(selectPaymentTypes);

  useEffect(() => {
    setPaymentTypes(paymentTypesFromAPI.paymentTypes); 
  }, [paymentTypesFromAPI]);

  useEffect(() => {
    if (rowSelectionPaymentsDetails.length === 0 || rowSelectionPaymentsDetails.length !== tableData.length){
      let newRowState:MRT_RowSelectionState[] = [];
      tableData.forEach(()=>newRowState.push({}));
      setRowSelectionPaymentsDetails(newRowState);
      setRowSelectionPayments({});
      setFilteredTableData(tableData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    let selectedData = cloneDeep(selectedTableData);
    let paymentsSelectedQuantity = 0;
    let clpTotalAmount = 0;
    let usdTotalAmount = 0;

    selectedData.forEach(row=> {
      paymentsSelectedQuantity++;
      clpTotalAmount += (row.currencyType === "CLP") ? row.amount : 0;
      usdTotalAmount += (row.currencyType === "USD") ? row.amount : 0;
    });

    setState({
      ...state,        
      pagosAConfirmar: paymentsSelectedQuantity,
      pagosCLP: clpTotalAmount,
      pagosUSD: usdTotalAmount,        
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTableData]);

  useEffect(() => {    
    let copyTableData = cloneDeep(tableData);
    let copyFilterText = cloneDeep(globalFilter);
    let copySelectedTableData = cloneDeep(selectedTableData);

    let newFilteredTableData = filterGroupedPayment(copyTableData, copyFilterText);
    let newSelectedRows:MRT_RowSelectionState = {};
    let newSelectedRowsDetail:Array<MRT_RowSelectionState> = [];

    newFilteredTableData.forEach((row, rowIndex) => {      
      let isSelectedCount = 0;
      (newSelectedRowsDetail[rowIndex] as Record<string, boolean>) = {};
      row.detail.forEach((det, detIndex) => {
        if (copySelectedTableData.find(s => s.id === det.id)){          
          isSelectedCount++;
          (newSelectedRowsDetail[rowIndex] as Record<string, boolean>)[detIndex] = true;
        }
      });

      if (isSelectedCount === row.detail.length){
        (newSelectedRows as Record<string, boolean>)[rowIndex] = true;
      }

    });

    setRowSelectionPayments(newSelectedRows);
    setRowSelectionPaymentsDetails(newSelectedRowsDetail);
    setFilteredTableData(newFilteredTableData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter]);

  const dateValidator = (fechainicio?: string) => (fechafin?: string) =>{
    let val = false;

    if (fechafin && fechafin !== initialState.fechaFin && fechainicio){
      val = Date.parse(fechafin.split("/").reverse().join()) < Date.parse(fechainicio.split("/").reverse().join())
    }        
    return val? ErrorValidations.EndDateGT : undefined;
  }

  const limpiarFiltroHandler = () => {
    setState(initialState);
    setTableData([]);
  }

  const handleClickGenerarConsulta = async () => {
    
    let newTableState = groupedPaymentTable.getState();
    newTableState.expanded = {}; 
    groupedPaymentTable.setState(newTableState);

    let error = false;
    let newState = state;
    //validaciones
    if (error || state.errorFechaFin || state.errorFechaInicio){
      setState(newState);
      return;
    }

    await consultaAPI()
  }

  function getFilters() : string {
    const medioPago = splitValue(state.medioPago ?? "");
    let filter = state.bancoRecaudador ? `&depositBank=${state.bancoRecaudador}`: "";    
    filter += state.entidadRecaudadora ? `&companyType=${state.entidadRecaudadora}`: "";
    filter += state.medioPago !== "0" ? `&paymentType=${medioPago[0]}`: "";
    if (1 in medioPago) {
      filter += state.medioPago ? `&tokuPaymentType=${medioPago[1]}`: "";
    }
    filter += state.fechaInicio ? `&dateFrom=${getApiDateFormat(state.fechaInicio)}`: "";
    filter += state.fechaFin ? `&dateTo=${getApiDateFormat(state.fechaFin)}`: "";
    return filter;
  }

  function getGroupedTable(result: PaymentModel[]):Array<GroupedPaymentModel> {    
    let data = new Array<GroupedPaymentModel>();

    if (!result || result?.length < 1){
      return [];
    }

    let rowId = 0;

    result.forEach((payment, index) => {
      let totalAmount = 0;

      let groupedPay: GroupedPaymentModel | undefined = undefined;

      if (payment.depositId){
        groupedPay = data.find(pay => 
          payment.depositId &&
          pay.depositId === payment.depositId) 
      } else {
        groupedPay = data.find(pay =>
          pay.companyType === payment.company &&
          pay.paymentType === payment.paymentType &&
          pay.currencyType === payment.currencyType &&
          pay.depositBank === payment.depositBank &&
          pay.paymentDate === getDateFromTimestamp(payment.paymentCreationDate!)
          );
      }

      if (groupedPay){
        groupedPay.paymentsQuantity++;
        totalAmount = groupedPay.total + payment.amount;
        groupedPay.total = totalAmount;
        
        groupedPay.detail.push({
          id: payment.id!,
          collectionId: payment.collectionId!,
          customerId: payment.customerId!,
          payerId: payment.payerId!,
          currencyType: payment.currencyType!,
          amount: payment.amount,
          index: index,
          rowId: groupedPay.id,
          detailRowId: groupedPay.detail.length
        });
      } else {
        totalAmount = payment.amount;
        data.push({
          id: rowId,
          collectionId: payment.collectionId!,
          paymentType: payment.paymentType!,
          companyType: payment.company!,
          paymentsQuantity: 1,
          currencyType: payment.currencyType!,
          total: totalAmount,
          depositBank: payment.depositBank!,
          depositId: payment.depositId!,
          paymentDate: getDateFromTimestamp(payment.paymentCreationDate!),
          detail: [{
            id: payment.id!,
            collectionId: payment.collectionId!,
            customerId: payment.customerId!,
            payerId: payment.payerId!,
            currencyType: payment.currencyType!,
            amount: payment.amount,
            index: index,
            rowId: rowId,
            detailRowId: 0
          }],
        });
        rowId++;
      }
      
    });    
    return data;
  }

  async function consultaAPI(){
    setIsLoadingTable(true);
    let filters = getFilters();
    let resultInicial = await getPaymentList(`page=1&size=1&status=1` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
      setTableData([]);
      setAlert({
        text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      })
      setIsLoadingTable(false);
      return;
    }

    let finalResult:PaymentModel[] = [];

    for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
      let params = `page=${page}&size=500&status=1` + filters;
      let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
      
      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setTableData([]);
        setAlert({
          text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
          variant: "error",
          detalleNoConfirmado: [],
          showTableDetalleNoConfirmado: false
        });
        setIsLoadingTable(false);
        return;
      }

      finalResult.push(...result.result);
    }

    let groupedTable = getGroupedTable(finalResult);
    if(groupedTable.length===0){      
      setTableData([]);
      setAlert({
        text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      });
      setIsLoadingTable(false);
      return;      
    }    
  
    setTableData(groupedTable);
    setSelectedTableData([]);
    setState({...state,
      pagosAConfirmar: 0,
      pagosCLP: 0,
      pagosUSD: 0,
    });
    setIsLoadingTable(false);
  }

  function handlerChangeDate(e:React.ChangeEvent<HTMLInputElement>, date: string): void {
    let oldDate = (date === "fecha-fin") ? state.fechaFin ?? "" : state.fechaInicio ?? "";
    let newDate = e.currentTarget.value;
    const regexp = /^[0-9/]+$/;

    if (
      (newDate && !regexp.test(newDate)) ||      
      (newDate.split("/").length === 1 && parseInt(newDate.split("/")[0]) > 31) ||
      (newDate.split("/").length === 2 && parseInt(newDate.split("/")[1]) > 12) ||
      (newDate.split("/").length === 3 && newDate.split("/")[2].length > 4) ||
      (newDate.match(/\//g)?.length === 1 && newDate.indexOf("/",0) !== 2) ||
      (newDate.match(/\//g)?.length === 2 && newDate.indexOf("/",3) !== 5) ||
      (newDate.match(/\//g)?.length ?? 0) > 2 ||
      newDate.length > 10    
      ){
      e.currentTarget.value = oldDate;
    } else {
      let error = "";

      if (newDate.length > 0 && isInvalidDate(newDate))
        error = ErrorValidations.InvalidDate;
      else if (newDate.length > 0 && newDate.length < 10)
        error = ErrorValidations.Required;

      if (date === "fecha-inicio"){
        setState({...state,
          fechaInicio: newDate,
          errorFechaInicio: error,
          calendarHiddenInicio: true
        })
      } else {
        setState({...state,
          fechaFin:newDate,
          errorFechaFin: error,
          calendarHiddenFin: true
        })
      }
    }
  }

  function isInvalidDate(date:string): boolean{    
    const [day, month, year] = date.split('/');
    const dateObj = new Date(+year, +month - 1, +day);    
    return (dateObj.toLocaleString('es-CL').substring(0,10).replaceAll("-","/") !== date);
  }

  async function descargarDetalleXLSX(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    let filters = getFilters();
    let resultInicial = await getPaymentList(`page=1&size=1&status=1` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
      setTableData([]);
      setAlert({
        text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      })
      return;
    }

    let finalResult:PaymentModel[] = [];

    for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
      let params = `page=${page}&size=500&status=1&userCreator=0` + filters;
      let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setTableData([]);
        setAlert({
          text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
          variant: "error",
          detalleNoConfirmado: [],
          showTableDetalleNoConfirmado: false
        })
        return;
      }

      finalResult.push(...result.result);
    }

    const titulo = [["Reporte de Confirmación de Pagos"]];
    const workBook=XLSX.utils.book_new()
    const workSheet=XLSX.utils.json_to_sheet(finalResult.map((p) => {
      return ({
        'RUT cliente': p.customerId,
        'RUT pagador':p.payerId,
        'Fecha de pago': p.paymentCreationDate,
        'Fecha devengo': p.accrualDate,
        'Monto': p.amount,
        'Moneda': p.currencyType,
        'Fecha recaudación': p.paymentConfirmDate,
        'Estado': p.status,
        'Medio de pago': p.paymentType,
        'Compañia Recaudadora': p.company,
        'Banco recaudador': p.depositBank,
        'Usuario Creador': p.userCreator,
        'ID Cobranza': p.collectionId
      })
    }),{origin: 'A2', cellStyles:true}); 

    //ingreso el titulo
    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });
    
    XLSX.utils.book_append_sheet(workBook,workSheet,"Confirmacion Pagos")
    //Buffer
    
    //Binary string
    XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Confirmacion Pagos.xlsx")    
  }

  async function descargarDetalleCSV(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    let filters = getFilters();
    let resultInicial = await getPaymentList(`page=1&size=1&status=1` + filters,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!resultInicial || typeof(resultInicial) === "string" || !resultInicial.result || resultInicial.result.length === 0){
      setTableData([]);
      setAlert({
        text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      })
      return;
    }

    let finalResult:PaymentModel[] = [];

    for (let page = 1 ; page < ((resultInicial.paging.total / 500) + 1); page ++){
      let params = `page=${page}&size=500&status=1&userCreator=0` + filters;
      let result = await getPaymentList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setTableData([]);
        setAlert({
          text:"No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados",
          variant: "error",
          detalleNoConfirmado: [],
          showTableDetalleNoConfirmado: false
        })
        return;
      }

      finalResult.push(...result.result);
    }

    const titulo = [["Reporte de Confirmación de Pagos"]];

    const workSheet=XLSX.utils.json_to_sheet(finalResult.map((p) => {
      return ({
        'RUT cliente': p.customerId,
        'RUT pagador':p.payerId,
        'Fecha de pago': p.paymentCreationDate,
        'Fecha devengo': p.accrualDate,
        'Monto': p.amount,
        'Moneda': p.currencyType,
        'Fecha recaudación': p.paymentConfirmDate,
        'Estado': p.status,
        'Medio de pago': p.paymentType,
        'Compañia Recaudadora': p.company,
        'Banco recaudador': p.depositBank,
        'Usuario Creador': p.userCreator,
        'ID Cobranza': p.collectionId
      })
    }),{origin: 'A2', cellStyles:true}); 

    //Tittle
    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });
    const workBook=XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workBook,workSheet,"Confirmacion Pagos")

    XLSX.write(workBook,{bookType:"csv",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Confirmacion de Pagos.csv" )    
  }

  async function confirmarPagos(){
    if (state.paymentsIds.length < 1){
      setAlert({
        text:"Ha ocurrido un error con los pagos a confirmar.",
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      })
      return;
    }

    let apiAnwswer = undefined;
    apiAnwswer = await paymentUpdateStatus({paymentIds: state.paymentsIds, newStatus: 3},userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);      

    if (typeof(apiAnwswer) === "string"){
      setAlert({
        text: apiAnwswer,
        variant: "error",
        detalleNoConfirmado: [],
        showTableDetalleNoConfirmado: false
      })
    } else {
      if (apiAnwswer.length > 0){         
        let newDetalleNoConfirmado:Array<PaymentModelDetail> = [];
        apiAnwswer.forEach((pay) => {
          let dpc = selectedTableData.find((d) => d.id === pay);
          if (dpc){
            newDetalleNoConfirmado.push(dpc);
          }
        })
        setAlert({
          text: `${apiAnwswer.length === 1 ? "El siguiente pago no fue confirmado: ": "Los siguientes pago no fueron confirmados: "}`,
          variant: "error",
          detalleNoConfirmado: newDetalleNoConfirmado,
          showTableDetalleNoConfirmado: false
        })
      } else {
        setAlert({
          text: "Pago(s) confirmado(s) exitosamente.",
          variant: "success",
          detalleNoConfirmado: [],
          showTableDetalleNoConfirmado: false
        })
      }
      setTableData([]);
      setSelectedTableData([]);
      setState({...state,
        pagosAConfirmar: 0,
        pagosUSD: 0,
        pagosCLP: 0,   
      })
        await consultaAPI();
    }
  }

  const groupedPaymentTable = useMaterialReactTable({
    columns: useMemo(() => columnsGroupedPayments,[]),
    data: filteredTableData ?? [],
    localization: {
      showHideSearch: "mostrar / ocultar búsqueda",
      search:"Búsqueda",
      sortByColumnAsc:"Ordernar por {column} ascendente",
      sortByColumnDesc:"Ordernar por {column} descendente",
      sortedByColumnAsc: 'Ordernado por {column} ascendente',
      sortedByColumnDesc: 'Ordernado por {column} descendente',
      selectedCountOfRowCountRowsSelected: '',
      select: 'Selección'
    },
    muiTablePaperProps:{
      style:{
        boxShadow:"none",
        height:"auto"
      },      
    },
    muiBottomToolbarProps:{
      style:{
        marginBottom:"25px",
      }
    },    
    enablePagination: false,
    enableColumnActions: false,
    enableDensityToggle:false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enableSelectAll: false,
    enableStickyHeader: true,
    enableGlobalFilter: true,
    enableExpandAll: true,
    onRowSelectionChange: (updater) => {      
      setRowSelectionPayments(updater);
      if (updater instanceof Function){
        let oldState = Object.keys(cloneDeep(rowSelectionPayments));
        let newState = Object.keys(updater(rowSelectionPayments));
        let newSelectedRows = newState.filter(s => !oldState.includes(s));
        let newUnselectedRows = oldState.filter(s => !newState.includes(s));

        let newFilteredTableData = cloneDeep(filteredTableData);
        let newRowSelectionPaymentsDetails = cloneDeep(rowSelectionPaymentsDetails);
        let newSelectedTableData = cloneDeep(selectedTableData);

        newSelectedRows.forEach(r => {
          newFilteredTableData[parseInt(r)].detail.forEach((d, index) => {            
            (newRowSelectionPaymentsDetails[parseInt(r)] as Record<string, boolean>)[index] = true;
            if (!newSelectedTableData.find(s=> s.id === d.id)){
              newSelectedTableData.push(d);
            }
          })
        })

        newUnselectedRows.forEach(r => {          
          (newRowSelectionPaymentsDetails[parseInt(r)] as Record<string, boolean>) = {};
          newFilteredTableData[parseInt(r)].detail.forEach(d =>{
            let element = newSelectedTableData.find(s=> s.id === d.id);
            if (element){
              newSelectedTableData.splice(newSelectedTableData.indexOf(element),1);
            }
          });
        });        

        setFilteredTableData(newFilteredTableData);
        setSelectedTableData(newSelectedTableData);
        setRowSelectionPaymentsDetails(newRowSelectionPaymentsDetails);
      };
      
    },    
    onGlobalFilterChange: setGlobalFilter,
    state:{ rowSelection: rowSelectionPayments, isLoading: isLoadingTable },
    muiDetailPanelProps: () => ({
      sx: (theme) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.1)'
            : 'rgba(200,200,200,0.1)',
      }),
    }),
    muiExpandButtonProps: ({ row }) => ({
      sx: {
        transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(-90deg)',
        transition: 'transform 0.2s',
      },
    }),       
    renderDetailPanel: ({row}) => 
      row.original.detail ? (
        <MaterialReactTable table={          
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useMaterialReactTable({
            // eslint-disable-next-line react-hooks/rules-of-hooks
            columns: useMemo(() => columnsGroupedPaymentsDetail,[]),
            data: row.original.detail ?? [],
            enablePagination: false,
            enableColumnActions: false,
            enableDensityToggle:false,
            enableFullScreenToggle: false,
            enableHiding: false,
            enableFilters: false,
            enableColumnFilters: false,
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSelectAll: false,
            enableStickyHeader: true,
            enableBottomToolbar: false,
            enableTopToolbar: false,
            muiTablePaperProps:{
              style:{
                boxShadow:"none",          
                width:"60em",          
                margin:"-1em 0em -1em 7em",
              },
            },
            localization: {
              showHideSearch: "mostrar / ocultar búsqueda",
              search:"Búsqueda",
              sortByColumnAsc:"Ordernar por {column} ascendente",
              sortByColumnDesc:"Ordernar por {column} descendente",
              sortedByColumnAsc: 'Ordernado por {column} ascendente',
              sortedByColumnDesc: 'Ordernado por {column} descendente',
              selectedCountOfRowCountRowsSelected: '',
              select: 'Selección'
            },
            onRowSelectionChange: (updater) => {
              if (updater instanceof Function){                                
                let newRowDetailState = updater(rowSelectionPaymentsDetails[parseInt(row.id)]);
                let newRowSelectionPaymentDetails = cloneDeep(rowSelectionPaymentsDetails);
                let newRowDetailSelectionIndex = Object.keys(newRowDetailState)
                newRowSelectionPaymentDetails[parseInt(row.id)] = newRowDetailState;

                let newFilteredTableData = cloneDeep(filteredTableData);
                let newSelectedTableData = cloneDeep(selectedTableData);
                newFilteredTableData[parseInt(row.id)].detail.forEach((d, index)=>{
                  let selectedItem = newSelectedTableData.find(s => s.id === d.id);
                  let isSelected = newRowDetailSelectionIndex.includes(index.toString());
                  if (isSelected && selectedItem === undefined){
                    newSelectedTableData.push(d);
                  } else if (!isSelected && selectedItem){
                    newSelectedTableData.splice(newSelectedTableData.indexOf(selectedItem),1);
                  }
                });
                
                row.toggleSelected(newFilteredTableData[parseInt(row.id)].detail.length === newRowDetailSelectionIndex.length);

                setSelectedTableData(newSelectedTableData);
                setRowSelectionPaymentsDetails(newRowSelectionPaymentDetails);
              }
            },
            state:{ rowSelection: rowSelectionPaymentsDetails[parseInt(row.id)]},
          })

        }/>
      ) : null
  });

  return(
    <div className={props.className}>
      <Title
        className={props.className + '-title'}
        text="Confirmación de pago"
      />
      <Card className="cp-filter">          
        <Card className="cp-filter-row">
        <InputFecha
            className="cp-filter-fecha"
            label="Fecha de inicio"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaInicio}              
            calendarhidden={state.calendarHiddenInicio}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {setState({...state,
              fechaInicio: e.toLocaleDateString().replaceAll("-","/"),
              calendarHiddenInicio: true,
              errorFechaInicio: e ? "" : state.errorFechaInicio
            })}}
            onClick={(e) => { setState({...state,
                calendarHiddenInicio: !state.calendarHiddenInicio,
                calendarHiddenFin: true,
                errorFechaInicio: e.currentTarget.value ? "" : state.errorFechaInicio
              })
            }}
            onMouseOver={() => setState({...state, calendarHiddenInicio: true})}
            error={state.errorFechaInicio}
            alt="fecha-inicio"
            onChange={(e) => handlerChangeDate(e,"fecha-inicio")}
          />
          <InputFecha
            className="cp-filter-fecha"
            label="Fecha de termino"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaFin}
            calendarhidden={state.calendarHiddenFin}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {setState({...state,
              fechaFin: e.toLocaleDateString().replaceAll("-","/"),
              calendarHiddenFin: true,
              errorFechaFin: e ? "" : state.errorFechaFin
            })}}
            onClick={(e) => { setState({...state,
              calendarHiddenFin: !state.calendarHiddenFin,
              calendarHiddenInicio: true,
              errorFechaFin: e.currentTarget.value ? "" : state.errorFechaFin
              })
            }}
            onMouseOver={() => setState({...state, calendarHiddenFin: true})}
            validators={[dateValidator(state.fechaInicio)]}
            error={state.errorFechaFin}
            alt="fecha-fin"
            onChange={(e) => handlerChangeDate(e,"fecha-fin")}
          />
          <InputSelect
            className="cp-filter-select"
            label="Filtrar por banco recaudador"              
            value={state.bancoRecaudador}
            values={BancoRecaudador}
            onChange={(evt) => setState({...state, bancoRecaudador: parseInt(evt.currentTarget.value) })}
            data-testid="banco-recaudador"
          />            
          <InputSelect
            className="cp-filter-select"
            label="Filtrar por entidad recaudadora"
            value={state.entidadRecaudadora}
            values={EntidadRecaudadora}
            onChange={(evt) => setState({...state, entidadRecaudadora: parseInt(evt.currentTarget.value) })}
            data-testid="entidad-recaudadora"
          />
          <InputSelect
            className="cp-filter-select"
            label="Filtrar por medio de pago"
            value={state.medioPago}
            values={paymentTypes}
            onChange={(evt) => setState({...state, medioPago: evt.currentTarget.value })}
            data-testid="medio-pago"
          />
        </Card>
        <Card style={{
          display: "flex",
          flexDirection: "row",
          width: "1392px",
          alignItems: "flex-end",
          gap: "24px"
        }}>            
          <Button
            style={{
              display: "flex",
              height: "48px",
              padding: "12px 32px",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              borderRadius: "25px",
              border: "1px solid #0061A0",
              background:"#FFFFFF",
              color: "#0061A0",
              textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "FS Elliot Pro Bold",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "21px"
            }}  
            text="Generar Consulta"
            onClick={handleClickGenerarConsulta}
          />
          <Button
            style={{
              display: "flex",
              height: "48px",
              padding: "10px 32px",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              borderRadius: "100px",
              border: "1px solid rgba(51, 51, 51, 0.00)",
              background: "rgba(51, 51, 51, 0.00)",
              color: "#0061A0",
              fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
              fontFamily: "FS Elliot Pro Bold",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "28px"
            }}  
            text="Limpiar filtros"
            onClick={limpiarFiltroHandler}
          />
        </Card>
      </Card>
      {alert.text  && 
        <Alert            
          text={alert.text}
          type={alert.variant}
          onClose={() => {
            setAlert({
              variant: undefined,
              text: '',
              detalleNoConfirmado: [],
              showTableDetalleNoConfirmado: false})
            }}
        >
          { alert.detalleNoConfirmado.length > 0 ?
            <Button
              text="Ver detalle"
              style={PrimaryButtonStyle}
              onClick={() => {
                setAlert({
                  ...alert,
                  showTableDetalleNoConfirmado: !alert.showTableDetalleNoConfirmado
                })
              }}
            /> : undefined}
        </Alert>
      }
      {alert.text && alert.showTableDetalleNoConfirmado && alert.detalleNoConfirmado.length > 0 &&
        alert.detalleNoConfirmado.map((dnc, index) => 
          <div key={'d'+index} style={DetalleNoConfirmadoStyle}>
            Rut cliente: {dnc.customerId} Rut pagador: {dnc.payerId} Moneda: {dnc.currencyType} Monto: {dnc.amount}              
          </div>
        )
      } 
      <Card style={SummaryTableStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "24px",              
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos a confirmar: {state.pagosAConfirmar}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
            <span style={SummaryAmountStyle}>
              Pagos en CLP: {moneyFormat(state.pagosCLP,"CLP")}
            </span>              
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flexStart",
              gap: "8px",
              color: "#333333"
            }}
          >
              <span style={SummaryAmountStyle}>
              Pagos en USD: {moneyFormat(state.pagosUSD.toFixed(2),"USD")}
            </span>              
          </div>
        </div>
        <Button
          style={{
            ...SecondaryButtonStyle,
            width:"20em"
          }}
          text="Confirmar Pago"
          onClick={() => {
            let paymentsIds:Array<string> = [];
            selectedTableData.forEach(row =>{
              paymentsIds.push(row.id);
            });
            setState({ ...state, paymentsIds: paymentsIds });
            if (state.pagosAConfirmar > 0) {
              setModalIsOpen(true);
            }
          }}
        />
      </Card>
      <div className="result">
        <div className="result-title">
        <Button
            className="result-title-download-button"
            text="Descargar detalle XLSX"              
            hidden={tableData === undefined || tableData.length < 1}
            onClick={descargarDetalleXLSX}
          >
            <LuDownload/>
          </Button>
          <Button
            className="result-title-download-button"
            text="Descargar detalle CSV"              
            hidden={tableData === undefined || tableData.length < 1}
            onClick={descargarDetalleCSV}
          >
            <LuDownload/>
          </Button>
        </div>
        {((tableData && tableData.length > 0) || isLoadingTable) &&
          <MaterialReactTable table={groupedPaymentTable}/>
        }
      </div>
        <Modal
          isOpen={modalIsOpen}
          hasCloseBtn={true}
          onClose={() => setModalIsOpen(false)}
          children={
            <ModalConfirm
              payments={selectedTableData}
              title="Está seguro que desea confirmar los siguientes pagos:"
              confirmButtonText="Confirmar"
              handleConfirm={() => {
                setModalIsOpen(false);
                confirmarPagos();
              }}
              handleCloseModal={() => setModalIsOpen(false)}
            />
          }
        />  
    </div>
    
  )
}

export default ConfirmacionPago;